import { FilterDropdown } from './FilterDropdown';
import { StatusFilterDropdown } from './StatusFilterDropdown';
import { STATUS_FILTER_VALUES, type StatusFilterValue } from './StatusFilterDropdown.constants';

// Re-export for backwards compatibility
export { STATUS_FILTER_VALUES, type StatusFilterValue };

/** Special key used to represent deliverables without a feature assigned */
export const NO_FEATURE_KEY = '__no_feature__';
/** Display label for deliverables without a feature */
export const NO_FEATURE_LABEL = 'No Feature';

export interface FilterControlsProps {
  uniqueTeams: string[];
  uniqueFeatures: string[];
  teamFilters: Set<string>;
  featureFilters: Set<string>;
  statusFilters: Set<StatusFilterValue>;
  onTeamFiltersChange: (filters: Set<string>) => void;
  onFeatureFiltersChange: (filters: Set<string>) => void;
  onStatusFiltersChange: (filters: Set<StatusFilterValue>) => void;
  teamColors: Record<string, string>;
  /** Optional children rendered at the end (e.g., ViewModeToggle) */
  children?: React.ReactNode;
}

/** Get display label for feature options (maps NO_FEATURE_KEY to readable label) */
const getFeatureDisplayLabel = (option: string): string => {
  if (option === NO_FEATURE_KEY) return NO_FEATURE_LABEL;
  return option;
};

/**
 * Filter controls molecule for results view
 *
 * Composes FilterDropdown and StatusFilterDropdown molecules
 * to provide comprehensive filtering options.
 */
export function FilterControls({
  uniqueTeams,
  uniqueFeatures,
  teamFilters,
  featureFilters,
  statusFilters,
  onTeamFiltersChange,
  onFeatureFiltersChange,
  onStatusFiltersChange,
  teamColors,
  children,
}: FilterControlsProps) {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <span className="text-sm text-text-muted">Filter by:</span>

      <FilterDropdown
        label="Teams"
        options={uniqueTeams}
        selected={teamFilters}
        onChange={onTeamFiltersChange}
        colorMap={teamColors}
      />

      <FilterDropdown
        label="Features"
        options={uniqueFeatures}
        selected={featureFilters}
        onChange={onFeatureFiltersChange}
        getDisplayLabel={getFeatureDisplayLabel}
      />

      <StatusFilterDropdown selected={statusFilters} onChange={onStatusFiltersChange} />

      {/* View toggle (or other children) pushed to the right */}
      {children && <div className="ml-auto">{children}</div>}
    </div>
  );
}
